import type { PortCallTypeRef } from '@gat-ship/types'
import { getPortCallTypeRefsRequest } from '../model/portcall-type-api-calls'
import { createListRefDataSource } from './create-list-ref-datasource'

/** Shared port-call-type ref cache for select/combobox pickers. */
export const portCallTypeRefDataSource =
  createListRefDataSource<PortCallTypeRef>({
    fetch: getPortCallTypeRefsRequest,
    debounceMs: 0
  })
